import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ResponseUploadFile, UpdateSolicitudDto, UpdateSolicitudesFolio, UploadFiles } from '../interfaces/upload-files.interfaces';
import { CoreService } from 'src/app/shared/services/core-service.service';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  private apiUrl = environment.baseUrlAuth;

  private http = inject(HttpClient);
  private coreService = inject(CoreService);


  uploadFilesDoc(body: UploadFiles): Observable<ResponseUploadFile> {
    const apiUrl = `${this.apiUrl}/api/documentos/create-documentos`;
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.post<ResponseUploadFile>(apiUrl, body, {headers})
    .pipe(
      // tap( resp => console.log(resp)),
      map((resp: ResponseUploadFile) => resp),
      catchError( err => {
        this.showErrorMessage(`Error al cargar los tipos de ID ${err.error.message}`);
        return throwError(() => err);
      })
    )
  }

  updateSolicitud(body: UpdateSolicitudDto, id: string): Observable<ResponseUploadFile> {
    const apiUrl = `${this.apiUrl}/api/documentos/updateSolicitud/${id}`;
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.patch<ResponseUploadFile>(apiUrl, body, {headers})
    .pipe(
      // tap( resp => console.log(resp)),
      map((resp: ResponseUploadFile) => resp),
      catchError( err => {
        this.showErrorMessage(`Error al actualizar la solicitud${err.error.message}`);
        if (err.error.message.includes('No se encontró el documento')) {
          this.coreService.openErrorSnackbar(`Error al actualizar la solicitud${err.error.message}`, 'OK');
        }
        return throwError(() => err);
      })
    )
  }

  // delele file from server
  deleteFileById(id: string, idSolicitud: string): Observable<any> {
    const apiUrl = `${this.apiUrl}/api/documentos/file/${idSolicitud}/${id}`;
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.delete<any>(apiUrl, {headers})
    .pipe(
      // tap( resp => console.log(resp)),
      map((resp: any) => resp),
      catchError( err => {
        this.showErrorMessage(`Error al eliminar el documento ${err.error.message}`);
        return throwError(() => err.error.message);
      })
    )
  }

  showErrorMessage(message: string): void {
    this.coreService.openErrorSnackbar(message, 'OK');
  }


  updateSolicitudFolios(body: UpdateSolicitudesFolio): Observable<ResponseUploadFile> {
    const apiUrl = `${this.apiUrl}/api/documentos/updateSolicitudMultiple`;
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.patch<ResponseUploadFile>(apiUrl, body, {headers})
    .pipe(
      // tap( resp => console.log(resp)),
      map((resp: ResponseUploadFile) => resp),
      catchError( err => {
        this.showErrorMessage(`Error al actualizar la solicitud${err.error.message}`);
        if (err.error.message.includes('No se encontró el documento')) {
          this.coreService.openErrorSnackbar(`Error al actualizar la solicitud${err.error.message}`, 'OK');
        }
        return throwError(() => err);
      })
    )
  }


  updateDocumentById(id: string, body: any): Observable<any> {
    const apiUrl = `${this.apiUrl}/api/documentos/updateDocumentById/${id}`;
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.patch<any>(apiUrl, body, {headers})
    .pipe(
      // tap( resp => console.log(resp)),
      map((resp: any) => {
        return resp;
      }),
      catchError( err => {
        this.showErrorMessage(`Error al actualizar el documento ${err.error.message}`);
        return throwError(() => err.error.message);
      })
    )
  }

  updateFoliosMuliple(body: any): Observable<any> {
    const apiUrl = `${this.apiUrl}/api/documentos/cambios-estado-asignacion-multiple`;
    const authToken = localStorage.getItem('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`
    });

    return this.http.patch<any>(apiUrl, body, {headers})
    .pipe(
      // tap( resp => console.log(resp)),
      map((resp: any) => {
        return resp;
      }),
      catchError( err => {
        // this.showErrorMessage(`Error al actualizar el documento ${err.error.message}`);
        return throwError(() => err);
      })
    )
  }





  // uploadFiles(files: File[]): Observable<any> {
  //   const formData = this.createFormData(files);
  //   return this.sendFormData(formData);
  // }

  // private createFormData(files: File[]): FormData {
  //   const formData = new FormData();
  //   for (const file of files) {
  //     formData.append('files', file);
  //   }
  //   return formData;
  // }

  // private sendFormData(body: FormData): Observable<any> {
  //   const apiUrl = `${this.apiUrl}/upload`;
  //   return this.http.post(apiUrl, body);
  // }
}
